export const groupLeaderFields = {
  title: "",
  first_name: "",
  last_name: "",
  phone: "",
  email: "",
  nationality: "",
  group_leader: false,
};

export const adtFields = {
  title: "",
  first_name: "",
  last_name: "",
  nationality: "",
};

export const chdFields = {
  title: "CH",
  first_name: "",
  last_name: "",
  nationality: "",
};
